export default {
  methods: {
    getPropertyValues(name) {
      const property = this.product.properties.find((p) => p.name === name);
      if (property && property.values) {
        return property.values.join(', ');
      }
      return '';
    },
    getOptionValues(name) {
      if (this.product.options === undefined) { return ''; }
      const option = this.product.options.find((o) => o.name === name);
      if (option && option.values) {
        return option.values.join(', ');
      }
      return '';
    },
  },
  computed: {
    productName() {
      let { name } = this.product;
      if (this.getPropertyValues('Clone').length > 0) {
        name += ` (${this.getPropertyValues('Clone')})`;
      }
      return name; // we used to add the Hôte at the end of the file
    },
  },
};
